import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import useOnScreen from '../../../ui/hooks/useOnScreen'

import noMediaImage from '../../../../images/svg/noMedia.svg'

const StyledImage = styled.img(({ render }) => ({
  objectFit: 'scale-down',
  maxWidth: ' 100%',
  height: 'auto',
  opacity: render ? 1 : 0,
  transition: 'opacity .3s ease-in',
  '@media (min-width: 1024px)': {
    height: 'auto',
    position: 'static',
  },
}))

const MediaImage = ({
  src,
  onLoad,
  lazy,
  containerRef,
}) => {
  const [render, setRender] = React.useState(!lazy)
  const imageRef = useRef()

  useOnScreen({
    target: imageRef,
    onEnterScreen: () => {
      if (lazy) setRender(true)
    },
  }, { root: containerRef })

  return (
    <StyledImage
      data-fallback="true"
      data-test="MediaImage"
      ref={imageRef}
      render={render}
      onLoad={onLoad}
      src={render ? src : noMediaImage}
    />
  )
}

MediaImage.propTypes = {
  src: PropTypes.string,
  onLoad: PropTypes.func,
  lazy: PropTypes.bool,
  containerRef: PropTypes.shape({}),
}

MediaImage.defaultProps = {
  src: '',
  lazy: true,
  containerRef: null,
  onLoad: () => false,
}

MediaImage.displayName = 'MediaImage'
MediaImage.whyDidYouRender = true

export default React.memo(MediaImage)
